<template>
  <section class="landing-testimonials">
    <tabs>
      <tab name="Cauê Ferreira" image="static/caue.png">
        <p>Bem, você gostaria de trabalhar em uma empresa repleta de amigos, que são os melhores devs que você conhece, todos muito legais, solícitos, humildes; onde você se diverte e aprende algo novo todo dia? Onde você trabalha com todo tipo de tecnologia e ainda tem tempo para trocar uma ideia e sair com a galera? Sim? Pois é, eu também.</p>
        <p class="name">Cauê Ferreira</p>
      </tab>
      <tab name="Filipe" image="static/filipe.png">
        <p>
          Porque aqui somos estimulados a inovar sem medo de errar. Além disso o respeito ao indivíduo é algo sempre presente, por isso não só desenvolvemos nossas habilidades profissionais mas também duradouras amizades.
        </p>
        <p class="name">Filipe Santos</p>
      </tab>
      <tab name="Caio Incau" image="static/caio.png">
        <p>Trabalhar no Moip é incrível, um local onde temos todo o apoio para nos desenvolvermos profissionalmente, além de tudo que a empresa propicia, o ambiente é ótimo para desenvolvermos amizades que vão além do dia a dia de trabalho.</p>
          <p class="name">Caio Incau</p>
      </tab>
      <tab name="Andre" image="static/andre.png">
        <p>Moip é de longe a empresa com a qual mais me identifiquei ao longo da minha carreira profissional! Nunca estive em outro lugar que incentivasse tanto o meu aprendizado e crescimento. As opiniões de todos tem valor desde o primeiro dia e isso para mim é um grande diferencial.</p>
          <p class="name">Andre Protti</p>
      </tab>
      <tab name="Gabriela Emi Sanada" image="static/gaby-2.jpg" :selected="true">
        <p>Nunca esperei trabalhar num lugar onde minha opinião fosse tão valorizada e respeitada quanto ela é aqui, por mais que eu possa estar errada aprendi a me expressar sem medo, pois sei que estou entre amigos.</p>
        <p class="name">Gabriela Emi Sanada</p>
      </tab>
    </tabs>
  </section>
</template>

<style lang="less">
  @import (reference) "../assets/styles/references";
  .landing-testimonials {
    .tabs-component {
      overflow-x: hidden;
    }
    @media @tablet {
      .tabs-component {
        margin: @xs-spacer;

        .tab-body {
          min-height: 220px;
        }
        .tab-item {
          width: ~"calc(100% - 80px)"
        }
      }
    }
    @media @phone {
      .section-title {
        font-size: 3.2rem;
      }
      .tabs-component {
        .tab-body {
          min-height: 290px;
        }
        .tab-item {
          font-size: 16px;
        }
      }
    }
  }
</style>


<script>
  import Tabs from '../components/Tabs'
  import Tab from '../components/Tab'

  export default {
    components: {
      Tabs, Tab
    }
  }
</script>



// WEBPACK FOOTER //
// LandingTestimonials.vue?62ea7589